import * as _ from 'lib/utilities';

const reqMeasures = ['waist']
const mRecMeasures = ['arms','shoulders','hips']
const fRecMeasures = ['shoulders','hips']
const mOptMeasures = ['chest','thighs','neck','forearms','calves']
const fOptMeasures = ['arms','chest','thighs','neck','forearms','calves']
const allMeasures = _.union(reqMeasures,mRecMeasures,fRecMeasures,mOptMeasures,fOptMeasures)

export { reqMeasures, mRecMeasures, fRecMeasures, mOptMeasures, fOptMeasures, allMeasures }